import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  height: 100%;
  overflow: auto;

  /* Estilizando a barra de rolagem */
  ::-webkit-scrollbar {
    width: 10px; /* Largura da barra de rolagem vertical */
    height: 10px; /* Altura da barra de rolagem horizontal */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* Cor do fundo da barra de rolagem */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888; /* Cor da barra de rolagem */
    border-radius: 10px; /* Arredondamento da barra de rolagem */
    border: 3px solid #f1f1f1; /* Espaço ao redor da barra de rolagem */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* Cor da barra de rolagem ao passar o mouse */
  }

  .message-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .message-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .eye-icon {
      margin-left: 8px;
      cursor: pointer;
      transition: color 0.2s;
      flex-shrink: 0;

      &:hover {
        color: #01579b;
      }
    }
  }

  table {
    thead th {
      background: ${({ theme }) => theme.colors.white};
      position: sticky;
      top: 0;
    }
    tbody {
      td {
        cursor: default;
      }
    }

    tr {
      td:not(:last-child) {
        padding-left: 10px;
      }
    }

    .date,
    .hour,
    .situation {
      padding-left: 10px;
      width: 10%;
    }

    .client,
    .phone {
      width: 13%;
    }

    .message {
      width: 50%;
      min-width: 200px; /* Largura mínima para evitar corte */
      word-wrap: break-word; /* Quebra de linha para evitar overflow */
      max-width: 0;
    }
  }
`;

export const MessagePreview = styled.div`
  position: fixed;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 250px;
  padding: 0;
  pointer-events: none;

  .preview-content {
    background: #dcf8c6;
    padding: 8px 12px;
    border-radius: 8px;
    color: #333;
    font-size: 12px;
    line-height: 1.4;
    max-height: 200px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      right: -8px;
      top: 10px;
      width: 0;
      height: 0;
      border-left: 8px solid #dcf8c6;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
    }
  }
`;

export const MessageModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;

  .modal-content {
    background: white;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      border-bottom: 1px solid #eee;

      h3 {
        margin: 0;
        color: #44546a;
        font-size: 16px;
      }

      button {
        background: none;
        border: none;
        font-size: 24px;
        color: #999;
        cursor: pointer;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          color: #666;
        }
      }
    }

    .modal-body {
      padding: 20px;
      overflow-y: auto;

      .whatsapp-message {
        background: #dcf8c6;
        padding: 12px 16px;
        border-radius: 12px;
        color: #333;
        line-height: 1.4;
        white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 14px;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          bottom: -2px;
          right: 15px;
          width: 0;
          height: 0;
          border-left: 10px solid #dcf8c6;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }
      }
    }
  }
`;
